import { ObjectHelpers } from "../../helpers/object-helpers";
import { Timeframe } from "../enum/timeframe.enum";

export class TimeframeOptionModel {
    public text = '';
    public symbol = '';
    public value = Timeframe.OneMinute;
    public timespan = '';
    
    constructor(data: any) {
        this.cast(data);
    }

    private cast(data: any) {
        ObjectHelpers.setProperties(data, this, true);
    }
}
